type BrandWordmarkProps = {
  className?: string;
  as?: 'span' | 'h1';
  id?: string;
};

export function BrandWordmark({ className = '', as: Tag = 'span', id }: BrandWordmarkProps) {
  return (
    <Tag id={id} className={`font-brand font-bold text-[#111818] ${className}`}>
      I&apos;d Go Back
    </Tag>
  );
}
